import { Loader } from "@devhop/ui";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";

export function AuthLayout() {
  const { isLoading, isAuthenticated } = useAuthState();
  const navigate = useNavigate({ from: "/auth" });

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: "/app/dashboard" });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-svh items-center justify-center bg-background">
        <Loader />
      </div>
    );
  }

  return (
    <div className="relative grid min-h-svh lg:grid-cols-[1fr_min(28rem,42%)]">
      <aside
        aria-hidden
        className="relative hidden overflow-hidden lg:flex lg:flex-col lg:justify-between lg:p-10 xl:p-14"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary/95 to-primary/80" />
        <div
          className="absolute inset-0 opacity-[0.12]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, currentColor 1px, transparent 0)",
            backgroundSize: "28px 28px",
          }}
        />
        <div className="relative">
          <p className="font-semibold text-3xl text-primary-foreground tracking-tight">
            freedom®
          </p>
          <p className="mt-2 text-lg text-primary-foreground/90">
            Management ERP
          </p>
          <p className="mt-4 max-w-md text-primary-foreground/75 text-sm leading-relaxed">
            ລະບົບບໍລິຫານພາຍໃນ — HR, ສຕັອກ, ເອກະສານ ແລະ ການດຳເນີນງານອົງກອນ
          </p>
        </div>
        <p className="relative text-primary-foreground/60 text-xs">
          © Freedom Brand
        </p>
      </aside>

      <main className="flex flex-col items-center justify-center bg-muted/40 px-4 py-10 sm:px-8">
        <div className="mb-8 w-full max-w-md text-center lg:hidden">
          <p className="font-semibold text-2xl tracking-tight">freedom®</p>
          <p className="mt-1 text-muted-foreground text-sm">Management ERP</p>
        </div>

        <div className="w-full max-w-md rounded-2xl border border-border/80 bg-card p-8 shadow-sm sm:p-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
